export default __webpack_public_path__ + "static/media/linkedInLogo.3574161a.svg";